module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video-tree-2-73bfe4eb543368b92e6c53b98962143f.png";